/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleListItem
 */
export interface BookingIdRemarkRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingIdRemarkRuleListItem
     */
    state?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleListItem
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleListItem
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleListItem
     */
    allowEdit?: boolean;
}

export function BookingIdRemarkRuleListItemFromJSON(json: any): BookingIdRemarkRuleListItem {
    return BookingIdRemarkRuleListItemFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BookingIdRemarkRuleListItemToJSON(value?: BookingIdRemarkRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': value.state,
        'description': value.description,
        'bookingIdRemark': value.bookingIdRemark,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


